import { Page, Pagebar } from '@monorepo/base/src/components/page/page';
import { Soon } from '@monorepo/base/src/components/soon/soon';
import { observer } from 'mobx-react';
import { Helmet } from 'react-helmet-async';

export const EditAccount = observer(() => {
	return (
		<Page>
			<Helmet>
				<title>Edit Account</title>
			</Helmet>
			<Pagebar>
				<Soon />
			</Pagebar>
		</Page>
	);
});
